import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integer-operator',
  templateUrl: './integer.component.html',
  styleUrls: ['./integer.component.css']
})
export class IntegerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
